export default __webpack_public_path__ + "static/media/be.b16164cd.svg";